import { X } from 'lucide-react';
import xeroLogo from '../../../assets/images/logo-xero.svg';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';

type SendPaymentToXeroCardProps = {
  onConnect: () => void;
  onClose: () => void;
};

export const SendPaymentToXeroCard = ({ onConnect, onClose }: SendPaymentToXeroCardProps) => {
  return (
    <Inline
      justify="between"
      className="relative w-full flex-wrap space-y-3 rounded-lg border-[0.5px] border-border bg-white p-[30px] md:flex-nowrap md:pr-[60px]"
    >
      <div className="absolute top-3 right-3">
        <Button variant="ghost" size="icon" aria-label="Hide Xero card" onClick={onClose}>
          <X className="h-5 w-5" />
        </Button>
      </div>

      <Inline space={3} className="flex-wrap md:flex-nowrap">
        <div className="mb-3 h-14 w-14 md:mb-0">
          <img src={xeroLogo} alt="" loading="eager" fetchpriority="high" className="h-full w-full object-contain" />
        </div>

        <Stack space={1}>
          <h3 className="text-xl leading-6 font-medium tracking-tight text-black">Send this payment to Xero</h3>

          <p className="text-base leading-6 font-medium tracking-tight text-muted-foreground">
            Sync Seapoint with Xero so every transaction lands in the right place, automatically.
          </p>
        </Stack>
      </Inline>

      <Button variant="default" size="lg" onClick={onConnect} className="w-full shrink-0 md:w-auto">
        Connect to Xero
      </Button>
    </Inline>
  );
};
